/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ServerTimeCorrectionEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SERVER_TIME_CORRECTION_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class ServerTimeCorrectionEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ServerTimeCorrectionEnabledSettingParser.decode(input).map(res => new ServerTimeCorrectionEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return ServerTimeCorrectionEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ServerTimeCorrectionEnabledSettingParser.encode(data);
    }
    static schema() {
        return ServerTimeCorrectionEnabledSettingParser.schema();
    }
}
